module.exports = __webpack_public_path__ + "img/user-empty-photo.a9e16dea.svg";